import { EditorCardProvider } from '@atlaskit/editor-card-provider/provider';
import type { CardAdf, DatasourceAdf } from '@atlaskit/linking-common/types';
import type { CardAppearance } from '@atlaskit/smart-card/card/types';
import { origin } from '@atlassian/help-center-common-util/location';
import { parseIssueKeyFromUrl } from '@atlassian/help-center-common-util/url';
import { canViewRequest } from '../rest';

const getSmartCardUrl = (issueKey: string) => {
	return `${origin()}/browse/${issueKey}`;
};

class PortalCardProviderNew extends EditorCardProvider {
	async resolve(
		url: string,
		appearance: CardAppearance,
	): Promise<CardAdf | DatasourceAdf<Record<string, unknown>>> {
		const issueKey = parseIssueKeyFromUrl(url);
		if (issueKey === null) {
			return super.resolve(url, appearance, false);
		}

		return canViewRequest(issueKey).then((canViewRequestInPortal) => {
			if (canViewRequestInPortal) {
				return super.resolve(getSmartCardUrl(issueKey), appearance, false);
			}
			return Promise.reject();
		});
	}
}

export { PortalCardProviderNew, getSmartCardUrl };
